import { Http } from './../helpers'
import { async } from 'q'

export const MaintenanceFeeService = {
  async search(params) {
    return await Http.get('/maintenance', { params: params })
  },
  async view(id) {
    return await Http.get('/maintenance/' + id)
  },
  async create(params) {
    return await Http.post('/maintenance', params)
  },
  async delete(id) {
    return await Http.delete('/maintenance/' + id)
  },
  async deleteDetail(id) {
    return await Http.delete('/maintenance/item/' + id)
  },
  async getImages(id) {
    return await Http.get('/maintenance/' + id + '/images')
  },
  async deleteImage(id, imageId) {
    return await Http.delete(
      '/maintenance/' + id + '/images/' + imageId + '/delete',
    )
  },
  async update(id, params) {
    return await Http.put('/maintenance/' + id, params)
  },
  async cancel(id) {
    return await Http.put('/maintenance/' + id + '/cancel')
  },
  async getInvoiceStatus() {
    return await Http.get('/maintenance/invoice-status')
  },
  async setInvoiceStatus(id, params) {
    return await Http.put('/maintenance/' + id + '/status', params)
  },

  async upload(id, data, headers) {
    return await Http.post('/maintenance/' + id + '/upload', data, {
      'Content-Type': 'multipart/form-data',
    })
  },
  async getGallery(id) {
    let photos = []
    this.getImages(id).then((rs) => {
      if (rs) {
        rs.data['data'].forEach((photo, index) => {
          photos.push({
            original: photo.url,
            thumbnail: photo.thumbnail,
          })
        })
      }
    })
    return photos
  },
}
